export default __webpack_public_path__ + "static/gallery-award-herblock-fbe7a9befc44a36e749d2c1cfa77eca2.jpg";